import React from 'react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';
import { aboutText } from '../../data/company';

const SuperiorProductsPage = () => {
  return (
    <div>
      <PageBanner
        title="Superior Products"
        breadcrumbs={[{ label: 'SUPERIOR PRODUCTS' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <SectionHeading title="Superior Products" />
          <p className="text-gray-600 leading-relaxed text-lg">
            {aboutText.superiorProducts}
          </p>
        </div>
      </section>
    </div>
  );
};

export default SuperiorProductsPage;
